import { render, staticRenderFns } from "./entity-card-families-detail-general-information.vue?vue&type=template&id=7749bbec&"
import script from "./entity-card-families-detail-general-information.vue?vue&type=script&lang=js&"
export * from "./entity-card-families-detail-general-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports